import React, { useState, useEffect, useCallback, useRef } from 'react'
import PropTypes from 'prop-types'
import Modal from 'react-modal'
import { FormattedMessage } from 'react-intl'

import { isNumber, PinInput } from '../Inputs/Inputs.jsx'

import styles from '../../../../css/notifications.module.css'

import AppDispatcher from '../../../dispatchers/AppDispatcher'

Modal.setAppElement('#app')

const ModalPinCode = ({ status, required }) => {
  const [in1, setIn1] = useState('')
  const [in2, setIn2] = useState('')
  const [in3, setIn3] = useState('')
  const [in4, setIn4] = useState('')
  const [, setPin] = useState('')
  const [inputStyle, setInputStyle] = useState(styles.pinCodeNumberInput)

  const in1Focus = useRef(null)
  const in2Focus = useRef(null)
  const in3Focus = useRef(null)
  const in4Focus = useRef(null)

  const inputFocus = useCallback((number) => {
    switch (number) {
      case 1:
        in1Focus.current?.focusInput()
        break
      case 2:
        in2Focus.current?.focusInput()
        break
      case 3:
        in3Focus.current?.focusInput()
        break
      case 4:
        in4Focus.current?.focusInput()
        break
      default:
        in1Focus.current?.focusInput()
    }
  }, [])

  const afterOpenModal = useCallback(() => {}, [])

  const closeModal = useCallback(() => {
    AppDispatcher.dispatch({
      action: 'pin-code-cancel',
    })
  }, [])

  const authenticatePinCode = useCallback((pin) => {
    AppDispatcher.dispatch({
      action: 'pin-code-authenticate',
      code: pin,
    })
  }, [])

  const handleChange = useCallback((field, value) => {
    if (
      isNumber(value) &&
      Number(value) >= 0 &&
      Number(value) <= 9
    ) {
      const valueNumber = Number(value)

      const updateField = (fieldName, newValue) => {
        switch (fieldName) {
          case 'in1':
            setIn1(newValue)
            break
          case 'in2':
            setIn2(newValue)
            break
          case 'in3':
            setIn3(newValue)
            break
          case 'in4':
            setIn4(newValue)
            break
          default:
            break
        }
      }

      updateField(field, valueNumber)

      switch (field) {
        case 'in1':
          inputFocus(2)
          break
        case 'in2':
          inputFocus(3)
          break
        case 'in3':
          inputFocus(4)
          break
        default:
          inputFocus(1)
      }
    } else if (value === '') {
      const updateField = (fieldName) => {
        switch (fieldName) {
          case 'in1':
            setIn1('')
            break
          case 'in2':
            setIn2('')
            break
          case 'in3':
            setIn3('')
            break
          case 'in4':
            setIn4('')
            break
          default:
            break
        }
      }

      updateField(field)
    }
  }, [authenticatePinCode, inputFocus, setIn1, setIn2, setIn3, setIn4])

  const childChange = useCallback((event) => {
    handleChange(event.target.name, event.target.value)
  }, [handleChange])

  const resetInputs = useCallback((callback) => {
    setIn1('')
    setIn2('')
    setIn3('')
    setIn4('')
    setPin('')
    setInputStyle(styles.pinCodeNumberInputReset)

    inputFocus(1)
    AppDispatcher.dispatch({
      action: 'pin-code-reset',
    })

    setTimeout(() => {
      setInputStyle(styles.pinCodeNumberInput)
    }, 1000)

    if (callback) callback()
  }, [inputFocus])

  useEffect(() => {
    // setTimeout(() => inputFocus(1), 2000);
  }, [inputFocus])

  useEffect(() => {
    const digits = [in1, in2, in3, in4]
    const hasFourDigits = digits.every(
      (digit) => digit !== '' && isNumber(digit)
    )
    if (hasFourDigits) {
      const newPin = digits.join('')
      setPin(newPin)
      authenticatePinCode(newPin)
    } else {
      setPin('')
    }
  }, [in1, in2, in3, in4, authenticatePinCode])

  useEffect(() => {
    if (status === 'wrongPin') {
      resetInputs()
    }
  }, [status, resetInputs])

  return (
    <Modal
      isOpen={
        status !== 'authenticated' &&
        required === true
      }
      onAfterOpen={afterOpenModal}
      onRequestClose={closeModal}
      className={{
        base: styles.pinCodeModalContent,
        afterOpen: styles.pinCodeModalContent_after_open,
        beforeClose: styles.pinCodeModalContent_before_close,
      }}
      overlayClassName={{
        base: styles.pinCodeModalOverlay,
        afterOpen: styles.pinCodeModalOverlay_after_open,
        beforeClose: styles.pinCodeModalOverlay_before_close,
      }}
      contentLabel='pin_code_modal'
    >
      <div className={styles.pinCodeModalContainer}>
        <button
          onClick={closeModal}
          className={`fa fa-times fa-2x ${styles.pinCodeExit}`}
          aria-hidden='true'
        />
        <div className={styles.pinCodeContainer}>
          <FormattedMessage
            id='pinCode.enter'
            defaultMessage='Enter Pin Code'
            description='Enter Pin Code'
            tagName='h3'
          />
          <h3>
            <PinInput
              ref={in1Focus}
              value={in1}
              field='in1'
              childChange={childChange}
              style={inputStyle}
              autoFocus
            />
            <PinInput
              ref={in2Focus}
              value={in2}
              field='in2'
              childChange={childChange}
              style={inputStyle}
            />
            <PinInput
              ref={in3Focus}
              value={in3}
              field='in3'
              childChange={childChange}
              style={inputStyle}
            />
            <PinInput
              ref={in4Focus}
              value={in4}
              field='in4'
              childChange={childChange}
              style={inputStyle}
            />
          </h3>
        </div>
      </div>
    </Modal>
  )
}

ModalPinCode.propTypes = {
  pageChange: PropTypes.bool,
  required: PropTypes.bool,
  status: PropTypes.string,
}

export default ModalPinCode
